import { get, post } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { GeneralApiError } from '@/domain/errors/GeneralApiError';
import { NotFoundError } from '@/domain/errors/NotFoundError';
import { APP_CONFIG } from '@/config';
import type { FreeExtensionCancellationStatus } from '@/@types/freeExtensionCancellation';

export const getFreeExtensionCancellationStatus = async (): Promise<FreeExtensionCancellationStatus | null> => {
  try {
    return await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.freeExtensionCancellation}`);
  } catch (error) {
    if (error instanceof NotFoundError) {
      return null;
    }

    throw error;
  }
};

export const requestFreeExtensionCancellation = async (): Promise<FreeExtensionCancellationStatus> => {
  const response = await post<FreeExtensionCancellationStatus, void>(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.freeExtensionCancellation}`,
    undefined,
    'XSRF-TOKEN',
  );

  if (response) {
    return response;
  }

  throw new GeneralApiError();
};
